import gql from 'graphql-tag';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

export function preloadPageStatusQuery(contentId: string) {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: gql`
			query preloadPageStatusQueryDataQuery($contentId: ID!) {
				content(id: $contentId, status: ["archived", "current"]) {
					nodes {
						id
						status
					}
				}
			}
		`,
		variables: {
			contentId,
		},
	});
}
